import { useParams } from "react-router-dom";
import { useWorkflow } from "../contexts/WorkflowContext";

export type StepKey =
  | "personal-information"
  | "contact-and-communication"
  | "address-and-identity"
  | "emergency-and-billing"
  | "care-and-insurance"
  | "medical-history"
  | "wellness-check"
  | "review-and-sign";

export function useAppointmentBasePath(): string {
  const { appointmentId } = useParams<{ appointmentId: string }>();
  return appointmentId ? `/appointments/${appointmentId}` : "";
}

// Returns the absolute path for a step key. Prefers the stepUrl reported by
// the backend workflow (so we never construct a route the workflow doesn't
// know about), with a constructed fallback for cases where workflow hasn't
// loaded yet or the step type isn't part of this patient's flow.
export function useAppointmentStepPath(key: StepKey): string {
  const basePath = useAppointmentBasePath();
  const { workflow } = useWorkflow();

  if (workflow?.steps) {
    const step = workflow.steps.find((step) => {
      const urlParts = step.stepUrl.split("/");
      const lastPart = urlParts[urlParts.length - 1];
      return lastPart === key;
    });
    if (step) {
      return step.stepUrl;
    }
  }

  return basePath ? `${basePath}/${key}` : `/${key}`;
}
